import React from 'react';
export const Nav00DataSource = {
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo makj1xpgz4-editor_css',
    children: 'https://i.postimg.cc/kgW9VV9g/logo.jpg',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>Home</p>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '#Content5_0',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>Success Case</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>Demo</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item maoznrx9c8g-editor_css',
              children: [
                {
                  name: 'content~map0lb7i6b',
                  className: '',
                  children: (
                    <span>
                      <p>2D sheet viewer</p>
                    </span>
                  ),
                },
              ],
              href: 'https://dxf.thingraph.site/',
              target: '_blank',
            },
          },
          {
            name: 'sub~maozr16v7p6',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'content~maozpuqdiw',
                  className: '',
                  children: (
                    <span>
                      <span>
                        <p>3D model viewer</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: 'https://bim.thingraph.site/#/',
              target: '_blank',
            },
          },
          {
            name: 'sub~maozr2t0m5o',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'content~maozpuqdiw',
                  className: '',
                  children: (
                    <span>
                      <span>
                        <p>Shopfitting design platform</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: 'https://bp3d.thingraph.site/#/',
              target: '_blank',
            },
          },
        ],
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '#Feature2_0',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>Contact us</p>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};
export const Banner01DataSource = {
  wrapper: { className: 'banner0 mauo8r54jtt-editor_css' },
  textWrapper: { className: 'banner0-text-wrapper mb03sm2iuq-editor_css' },
  title: {
    className: 'banner0-title',
    children: 'https://i.postimg.cc/mkcWTk8R/logo2.png',
  },
  content: {
    className: 'banner0-content mb03cb3l52k-editor_css',
    children: (
      <span>
        <span>
          <p>
            ThinGraph focuses on 2D/3D graphics rendering technology, and is
            committed to providing leading display and simulation solutions in
            the fields of industry, architecture, home improvement, digital
            twins, etc., driving the infinite possibilities of future
            visualization.
          </p>
        </span>
      </span>
    ),
  },
  button: { className: 'banner0-button', children: 'Learn More' },
};
export const Content00DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>Products &amp; Services</p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/WBnVOjtIlGWbzyQivuyq.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <span>
                    <p>Smart parks</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        Optimize resource management, improve operational
                        efficiency, and create high-quality space
                      </p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/YPMsLQuCEXtuEkmXTTdk.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <span>
                    <p>Smart computer room</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>
                            3D visualized O&amp;M and intelligent monitoring
                            reduce O&amp;M costs and improve data center
                            reliability
                          </p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/EkXWVvAaFJKCzhMmQYiX.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <span>
                    <p>Smart Cities</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <p>
                      Urban digital twins break down information silos, optimize
                      resource allocation, improve governance, and promote
                      sustainable development
                    </p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Content50DataSource = {
  wrapper: { className: 'home-page-wrapper content5-wrapper' },
  page: { className: 'home-page content5' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>Customer stories</p>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: (
          <span>
            <span>
              <p>
                With innovative technology as the core, we are committed to
                providing customers with efficient and intelligent solutions to
                help enterprises achieve digital transformation and sustainable
                development
              </p>
            </span>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'content5-img-wrapper',
    gutter: 16,
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content maupkbvn7ta-editor_css',
            href: '',
            target: '',
          },
          img: {
            children: 'https://i.postimg.cc/s2yz5VD9/project1.jpg',
            className: 'makqb9q8ip-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <p>Smart parks</p>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children: 'https://i.postimg.cc/qRvdZjKN/project3.jpg',
            className: 'makqfgqnn1b-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <p>Smart computer room</p>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children: 'https://i.postimg.cc/44cBd6jW/image.jpg',
            className: 'makqhbp7afl-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <p>Smart Cities</p>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block~maus9dyu5g6',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children: 'https://i.postimg.cc/T1TZYK72/image.gif',
            className: 'makqos0bo-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>Interior decoration</p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block~maus9f2d7zb',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children: 'https://i.postimg.cc/wTv8Zb11/image.gif',
            className: 'makqos0bo-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>Collaborative platform</p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block3',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children: 'https://i.postimg.cc/wxFYWdjK/bp3d-2.gif',
            className: 'makqos0bo-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <p>Interior Design Platform</p>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
    ],
  },
};
export const Feature20DataSource = {
  wrapper: { className: 'home-page-wrapper content2-wrapper' },
  OverPack: { className: 'home-page content2', playScale: 0.3 },
  imgWrapper: { className: 'content2-img', md: 10, xs: 24 },
  img: {
    children:
      'https://i.postimg.cc/8PYSZ364/qrcode-for-gh-f7543a977cc1-258.jpg',
  },
  textWrapper: { className: 'content2-text', md: 14, xs: 24 },
  title: {
    className: 'content2-title',
    children: (
      <span>
        <span>
          <p>Contact us</p>
        </span>
      </span>
    ),
  },
  content: {
    className: 'content2-content',
    children: (
      <span>
        <span>
          <span>
            <span>
              <span>
                <p>
                  Connect reality with digital twins and put the value of data
                  at your fingertips
                </p>
                <p>
                  We focus on visualization technology infrastructure, providing
                  full-stack solutions from data mapping to scene interaction
                  for construction, smart city, industrial manufacturing and
                  other fields.
                </p>
              </span>
            </span>
          </span>
        </span>
      </span>
    ),
  },
};
export const Footer20DataSource = {
  wrapper: { className: 'home-page-wrapper footer2-wrapper' },
  OverPack: { className: 'home-page footer2', playScale: 0.05 },
  copyright: {
    className: 'copyright',
    children: [
      {
        name: 'group',
        children: (
          <span>
            <br />
          </span>
        ),
        className: 'copyright-group',
      },
      {
        name: 'image2',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/fgGmQUfiUfSBfvsQpfOj.svg',
        className: 'copyright-line',
      },
      {
        name: 'copyright',
        children: (
          <span>
            <p>Copyright © ThinGraph</p>
          </span>
        ),
        className: 'copyright-text',
      },
    ],
  },
  links: {
    className: 'links',
    children: [
      {
        name: 'zhihu',
        href: 'https://www.youtube.com/@ThinGraph',
        className: 'links-zhihu',
        children:
          'data:image/svg+xml;charset=utf-8;base64,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',
        target: '_blank',
      },
      {
        name: 'zhihu~map0edzuo8',
        href: 'mailto:thingraph@outlook.com',
        className: 'links-zhihu',
        children:
          'data:image/svg+xml;charset=utf-8;base64,PHN2ZyB0PSIxNzQ3MjkxNzQ0MDI5IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM3NTUiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PHBhdGggZD0iTTEwMjQuMDAxNDQgMjIwLjY0djU3NC4zMmMwIDUuNzYtMC43MzYgMTEuNDU2LTEuODI0IDE3LjA3MnYwLjA2NGwtMC4yMjQgMC45NDRBODQuMzM2IDg0LjMzNiAwIDAgMSA5MzkuMjk3NDQgODgwSDEwMS4wODk0NGExMDIuNzIgMTAyLjcyIDAgMCAxLTgyLjUxMi00MC44MzIgOTUuOTA0IDk1LjkwNCAwIDAgMS0xOC41Ni01Ny4yNDhWMjM2LjI1NmE3NC4wOCA3NC4wOCAwIDAgMSA1Mi4wNjQtNzAuNzg0bDAuNzM2LTAuMjA4IDAuMjA4LTAuMDhBMTI3LjY0OCAxMjcuNjQ4IDAgMCAxIDg5LjY2NTQ0IDE2MGg4ODMuNDI0YzEuMzI4IDAuNTEyIDIuNjQgMS4yMzIgNC4wMzIgMS40NCAyNS41MiA0LjMyIDQwLjU5MiAxOS4xNTIgNDUuMzQ0IDQ0LjQ5NnYwLjA4YzAuODggNC44MTYgMS41MzYgOS43MTIgMS41MzYgMTQuNjA4ek01MTIuMDAxNDQgNTkxLjIzMmw0NTEuMTUyLTM3OS40NzJjLTY2LjI3Mi0zLjg4OC04ODguNDgtMS43MjgtODk3Ljg0IDIuMzY4TDUxMi4wMDE0NCA1OTEuMnYwLjA2NHogbTEzMy44NTYtNDUuMTUybC0xMTQuMTEyIDk2LjE0NGMtMTMuNzYgMTEuNTItMjUuNiAxMS42NjQtMzkuMiAwLjIwOGwtNDguMjcyLTQwLjc1Mi02My44NC01My45MzZMODEuMDI1NDQgODI1LjI4bDEuMDI0IDIuMzA0aDg3My4zMjhMNjQ1Ljc5MzQ0IDU0Ni4wOGgwLjA2NHogbS0zMDQuODY0LTMxLjY4TDUxLjc5MzQ0IDI3MC4wMzJ2NTEyLjQ4bDI4OS4yOC0yNjguMDk2aC0wLjA4eiBtMzQ0LjM1Mi0xLjY0OGwyODcuMDg4IDI2MC45NlYyNzAuOTQ0TDY4NS4zNDU0NCA1MTIuNzY4eiIgZmlsbD0iI2ZmZmZmZiIgcC1pZD0iMzc1NiI+PC9wYXRoPjwvc3ZnPg==',
        type: 'default',
      },
    ],
  },
};
